<template>
  <!-- App.vue acts as the top-level container for your application. -->
  <!-- It imports and renders the Home component, which contains the actual content. -->
  <Home />
</template>

<script>
// IMPORTANT: Adjust this path if your Home.vue file is not in a 'views' folder.
// A common structure is `src/App.vue` imports `src/views/Home.vue`.
import Home from './views/Home.vue';

export default {
  name: 'App',
  components: {
    Home,
  },
};
</script>

<style>
/* Global styles for the application can go here */

/* Stops mobile browsers' native "pull to refresh" gesture from reloading the
   whole app when a user swipes down past the top of a scrolled view (the
   common case is just swiping up to get back to the top, not asking to
   reload). Scroll bounce/rubber-banding elsewhere is unaffected. */
html {
  overscroll-behavior-y: contain;
}

/* Floating label of an outlined field (Search/Filter boxes on every page).
   Keeps the label readable over the border once the box has text or focus, and
   paints its patch in the same colour as the field's own fill so a tinted box
   (bg-color="light-blue-lighten-5" while it has text) doesn't show a white
   rectangle behind the label. Previously scoped to RecordsView only, so
   Agencies/Research/Docket boxes lost the label. */
.v-field--variant-outlined {
  --ccm-label-bg: #fff;
}
.v-field--variant-outlined.bg-light-blue-lighten-5 {
  --ccm-label-bg: #E1F5FE;
}
.v-field--variant-outlined.v-field--focused .v-label.v-field-label--floating,
.v-field--variant-outlined.v-field--dirty .v-label.v-field-label--floating {
  z-index: 1;
  background: var(--ccm-label-bg);
  padding: 0 4px;
}

/* Library status pill whose label is split over two lines by
   statusLabelLines() in composables/useReportStatus.js ("New Ratings" /
   "Needed"). A v-chip is a fixed-height single line by default. */
.v-chip.status-chip-two-line {
  height: auto;
  padding-top: 2px;
  padding-bottom: 2px;
}
.v-chip.status-chip-two-line .v-chip__content {
  flex-direction: column;
  white-space: normal;
  text-align: center;
  line-height: 1.15;
}

/* Copy-button feedback.
   Applied by setupCopyDelegation() in utils/formatters.js, which is the single
   handler for every .copy-inline-btn on the site — the 📋 buttons generated by
   formatAndLinkUrls() and the report-path button on the Research page.

   The marker is a ::after badge rather than a swap of the button's contents,
   because those two button types hold different things (a text-node emoji vs a
   Vue-rendered <v-icon>). Replacing innerHTML would work for the first and risk
   being clobbered by Vue's next patch for the second; an overlay touches
   neither. */
.copy-inline-btn {
  position: relative;
}
/* Local-file open button from formatAndLinkUrls() — looks like a link. */
.open-file-btn {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
}
.open-file-btn.open-fail {
  color: #b71c1c;
}
.copy-inline-btn.copy-ok::after,
.copy-inline-btn.copy-fail::after {
  position: absolute;
  top: -6px;
  right: -9px;
  font-size: 11px;
  font-weight: bold;
  line-height: 1;
  padding: 1px 3px;
  border-radius: 3px;
  pointer-events: none;
}
.copy-inline-btn.copy-ok::after {
  content: "✓";
  color: #1b5e20;
  background: #c8e6c9;
}
/* Failure has to be visible on the button too, not only in a snackbar — a
   silent failure that still looks like success is the exact bug this feedback
   exists to prevent. */
.copy-inline-btn.copy-fail::after {
  content: "✕";
  color: #b71c1c;
  background: #ffcdd2;
}
</style>
